import { ReactNode } from 'react';
import { cssWhen } from '../../../shared/utils/themeUtils';
import classes from './NotificationCounter.module.scss';

export interface NbNotificationCounterProps {
  children: ReactNode;
  mode?: 'green' | 'red';
  className?: string;
  isLong?: boolean;
  size?: 'small' | 'normal';
}

export const NbNotificationCounter = ({ children, mode, className, isLong, size }: NbNotificationCounterProps) => {
  return (
    <span
      className={cssWhen(
        classes.counter,
        [!mode || mode === 'red', classes.counterIsRed],
        [mode === 'green', classes.counterIsGreen],
        [className !== undefined, className as string],
        [isLong, classes.counterIsLong],
        [size === 'small', classes.counterIsSmall],
      )}
    >
      {children}
    </span>
  );
};
